import { useEffect, useState } from 'react';

// Глобальная "загрузка один раз"
let ymapsLoadingPromise: Promise<void> | null = null;

export function useYandexMaps(apiKey: string, enabled = true) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false); // optional, но полезно

  useEffect(() => {
    if (!enabled) return;
    if (typeof window === 'undefined') return;

    // уже загружено
    if (window.ymaps?.Map) {
      setIsLoaded(true);
      return;
    }

    const scriptId = 'yandex-maps-script';

    // если уже грузится — подписываемся на общий промис
    if (ymapsLoadingPromise) {
      ymapsLoadingPromise.then(() => setIsLoaded(true)).catch(() => setIsFailed(true));
      return;
    }

    let script = document.getElementById(scriptId) as HTMLScriptElement | null;

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=ru_RU`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    ymapsLoadingPromise = new Promise<void>((resolve, reject) => {
      const onLoad = () => {
        const ymaps = window.ymaps;

        if (ymaps?.ready) {
          ymaps.ready(() => resolve());
        } else {
          // скрипт загрузился, но ymaps не появился — всё равно резолвим, чтобы не зависнуть
          resolve();
        }
      };

      const onError = () => reject(new Error('Failed to load Yandex Maps script'));

      script!.addEventListener('load', onLoad, { once: true });
      script!.addEventListener('error', onError, { once: true });
    });

    ymapsLoadingPromise
      .then(() => setIsLoaded(true))
      .catch(() => {
        ymapsLoadingPromise = null; // ✅ чтобы можно было попробовать снова
        setIsFailed(true);
      });

    // cleanup не обязателен (once:true), но пусть будет
    return () => {};
  }, [apiKey, enabled]);

  return { isLoaded, isFailed };
}
